export const SET_ENROLLMENT_STATUS = '@userEnrollment/SET_ENROLLMENT_STATUS';
export const SET_AUTHENTICATING_STATUS = '@userEnrollment/SET_AUTHENTICATING_STATUS';
